import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { Tooltip } from 'react-tooltip';

/**
 * SearchTabsNavigation - Reusable tab navigation for search pages
 *
 * Renders a horizontal tab bar with tooltips for disabled tabs.
 *
 * @param {Array} tabs - Array of tab objects with:
 *   - id: string - Unique identifier
 *   - name: string - Display name
 *   - isSelected: boolean - Whether tab is currently active
 *   - disabled: boolean - Whether tab is disabled
 *   - setTabValue: function - Callback when tab is clicked
 *   - tooltipContent: React.ReactNode - Optional tooltip for disabled state
 */
const SearchTabsNavigation = observer(({ tabs }) => {
  return (
    <Fragment>
      <div className="tabs">
        <div className="tabs-scrollable-container">
          {tabs.map(({ id, name, isSelected, disabled, setTabValue }) => {
            const classNames = ['tab'];
            if (isSelected) {
              classNames.push('selected');
            }
            if (disabled) {
              classNames.push('disabled');
            }
            const className = classNames.join(' ');
            return (
              <div
                id={id}
                className={className}
                key={id}
                onClick={() => {
                  if (isSelected || disabled) {
                    return;
                  }
                  setTabValue();
                }}
              >
                {name}
              </div>
            );
          })}
        </div>
      </div>
      {tabs
        .filter((t) => t.tooltipContent)
        .map(({ id, tooltipContent }) => {
          return (
            <Tooltip
              key={id}
              anchorSelect={`#${id}`}
              multiline={true}
              variant="dark"
              opacity={1}
              place="bottom-center"
              className="icon-button-tooltip tooltip-type-default"
              clickable
              {...{ children: tooltipContent }}
            />
          );
        })}
    </Fragment>
  );
});

export default SearchTabsNavigation;
